import i18n from 'i18n-js';

export const AccessDeviceStatuses = () => [
  { value: 'ACTIVE', label: i18n.t('nfc.status.ACTIVE') },
  { value: 'UNASSIGNED', label: i18n.t('nfc.status.UNASSIGNED') },
];

export const ExternalTypes = () => [
  { value: 'hitag_1', label: 'hitag_1' },
  { value: 'iso14443a_mifare', label: 'iso14443a_mifare' },
  { value: 'iso14443a_4', label: 'iso14443a_4' },
  { value: 'iso14443b_4', label: 'iso14443b_4' },
  { value: 'felica', label: 'felica' },
  { value: 'iso15693', label: 'iso15693' },
  { value: 'hid_prox', label: 'hid_prox' },
  { value: 'hid_iclass', label: 'hid_iclass' },
  { value: 'awid', label: 'awid' },
  { value: 'indala', label: 'indala' },
  { value: 'iso14443b_prime', label: 'iso14443b_prime' },
  { value: 'em_410x', label: 'em_410x' },
];
